module.exports = __webpack_public_path__ + "img/thermometer-half.dfe01fe0.svg";